<template>
  <b-card header="true" header-tag="header">
    <div
      slot="header"
      class="d-flex justify-content-between align-items-center"
    >
      <p class="mb-0 d-inline-block align-middle">
        <b>{{ title }}</b>
      </p>
    </div>
    <div class="details-card custom-grid-wrapper">
      <template v-for="(row, index) in rows">
        <div
          :class="{
            even: index % 2 === 0,
            odd: index % 2 !== 0,
            'grid-item-label': true,
          }"
          :key="`label_${index}`"
        >
          <strong>{{ row.label.toUpperCase() }}</strong>
        </div>
        <div
          :class="{
            even: index % 2 === 0,
            odd: index % 2 !== 0,
            'grid-item-value': true,
          }"
          :key="`value_${index}`"
          v-html="row.value"
        ></div>
      </template>
    </div>
  </b-card>
</template>

<script>
/*
 * Resa condivisa dei tab di dettaglio del titolo: una card con una griglia
 * etichetta/valore. I dati li costruisce il tab che la usa.
 */
export default {
  name: "InfoCard",
  props: {
    title: {
      type: String,
      required: true,
    },
    rows: {
      type: Array,
      default() {
        return [];
      },
    },
  },
};
</script>
